import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConstants } from "../app_setting/app-constants";
import { BaseResponse } from "../models/base-response";
import { environment } from "src/environments/environment";

export enum ContentTypeEnum {
  JSON,
  FORMDATA,
}

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class BaseService {
  constructor(protected httpClient: HttpClient) { }

  get: Function = (url: string) => {
    this.buildHttpsHeaders();
    return this.httpClient.get<BaseResponse>(
      `${environment.apiBaseUrl}${url}`,
      httpOptions
    );
  };

  getGt: Function = (url: string) => {
    this.buildHttpsHeaders();
    return this.httpClient.get<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      httpOptions
    );
  };

  getFile: Function = (url: string) => {
    this.buildHttpsHeaders();
    return this.httpClient.get(`${environment.apiBaseUrl}${url}`, {
      headers: httpOptions.headers,
      responseType: "blob",
    });
  };

  post: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrl}${url}`,
      param,
      httpOptions
    );
  };

  postGt: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  postPromo: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrlPromo}${url}`,
      param,
      httpOptions
    );
  };

  postMultipartFormData: Function = (url: string, param: any) => {
    const token = localStorage.getItem(AppConstants.TokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set(AppConstants.TokenId, "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrl}${url}`,
      param,
      httpOptions
    );
  };

  postGtMultipartFormData: Function = (url: string, param: any) => {
    const token = localStorage.getItem(AppConstants.TokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set(AppConstants.TokenId, "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  putMultipartFormData: Function = (url: string, param: any) => {
    const token = localStorage.getItem(AppConstants.TokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set(AppConstants.TokenId, "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());

    return this.httpClient.put<BaseResponse>(
      `${environment.apiBaseUrl}${url}`,
      param,
      httpOptions
    );
  };

  put: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.put<BaseResponse>(
      `${environment.apiBaseUrl}${url}`,
      param,
      httpOptions
    );
  };

  private getTimeZone: Function = () => {
    const timeZoneOffset = new Date().getTimezoneOffset();
    if (timeZoneOffset < 0) {
      return `UTC+0${timeZoneOffset / -60}:00`;
    } else {
      return `UTC-0${timeZoneOffset / 60}:00`;
    }
  };

  private buildHttpsHeaders() {
    const token = localStorage.getItem(AppConstants.TokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set(AppConstants.TokenId, "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());
  }
}
